<template>
  <div>
    <InputDialog ref="inputDialog"></InputDialog>
    <TextareaDialog ref="textareaDialog"></TextareaDialog>
    <HintEditorDialog ref="hintEditorDialog"></HintEditorDialog>
    <InfoDialog ref="infoDialog"></InfoDialog>
    <InfoShortDialog ref="infoShortDialog"></InfoShortDialog>
    <ErrorDialog ref="errorDialog"></ErrorDialog>
    <YesNoDialog ref="yesnoDialog"></YesNoDialog>
    <PendingDialog ref="pendingDialog"></PendingDialog>
    <LoggedOffDialog ref="loggedOffDialog"></LoggedOffDialog>
    <CountDownDialog ref="countDownDialog"></CountDownDialog>
    <ChangePasswordDialog ref="changePasswordDialog"></ChangePasswordDialog>
    <SelectInDataGridDialog ref="selectInDataGridDialog"></SelectInDataGridDialog>
    <SelectInComboDialog ref="selectInComboDialog"></SelectInComboDialog>
    <ImportOrUpdateProductDialog ref="importOrUpdateProductDialog">
    </ImportOrUpdateProductDialog>
    <UpdateDynamicAttributesDialog ref="updateDynamicAttributesDialog"></UpdateDynamicAttributesDialog>
    <CheckboxDialog ref="checkboxDialog"></CheckboxDialog>
    <DateDialog ref="dateDialog"></DateDialog>
    <NumericDialog ref="numericDialog"></NumericDialog>
    <MultiSelectDialog ref="multiSelectDialog"></MultiSelectDialog>
    <PrintoutLanguageDialog ref="inquiryDialog"></PrintoutLanguageDialog>
    <InfoNewOrganization ref="infoNewOrganization"></InfoNewOrganization>
    <BinaryOptionDialog ref="binaryOptionDialog"></BinaryOptionDialog>

    <ShareAttachmentDialog ref="shareAttachmentDialog"></ShareAttachmentDialog>
    <ColumnsDialog ref="columnsDialog"></ColumnsDialog>
    <HelpDialog ref="helpDialog"></HelpDialog>
    <CloseUnsavedDialog ref="closeUnsavedDialog"></CloseUnsavedDialog>

    <div v-if="login">
      <DeleteDepartmentDialog ref="deleteDepartmentDialog"></DeleteDepartmentDialog>
      <ImageDialog ref="imageDialog"></ImageDialog>
      <MailBrowserDialog ref="mailBrowserDialog"></MailBrowserDialog>
      <AttachmentDialog ref="attachmentDialog"></AttachmentDialog>
      <ListOfImagesDialog ref="listOfImagesDialog"></ListOfImagesDialog>
      <SaveOrReplaceDialog ref="saveOrDeleteDialog"></SaveOrReplaceDialog>
      <RegionDialog ref="regionsDialog"></RegionDialog>
      <TranslationDialog ref="translationDialog"></TranslationDialog>
      <InterfaceLanguageDialog ref="interfaceLanguageDialog"></InterfaceLanguageDialog>
    </div>
  </div>
</template>

<script>
import InputDialog from "@/components/dialogs/LineInputDialog";
import TextareaDialog from "@/components/dialogs/TextareaDialog";
import HintEditorDialog from "@/components/dialogs/HintEditorDialog";
import InfoDialog from "@/components/dialogs/InfoDialog";
import ErrorDialog from "@/components/dialogs/ErrorDialog";
import YesNoDialog from "@/components/dialogs/YesNoDialog";
import PendingDialog from "@/components/dialogs/PendingDialog";
import LoggedOffDialog from "@/components/dialogs/LoggedOffDialog";
import CountDownDialog from "@/components/dialogs/CountDownDialog";
import ChangePasswordDialog from "@/components/dialogs/ChangePasswordDialog";
import ImageDialog from "@/components/dialogs/ImageDialog";
import ColumnsDialog from "@/components/datagrid/ColumnsDialog";
import MultiSelectDialog from "@/components/dialogs/MultiSelectDialog"
import Log from "@/utils/Log";
import SelectInDataGridDialog from "@/components/dialogs/SelectInDataGridDialog";
import AttachmentDialog from "@/components/dialogs/AttachmentDialog";
import ListOfImagesDialog from "@/components/dialogs/ListOfImagesDialog.vue";
import ShareAttachmentDialog from "@/components/dialogs/ShareAttachmentDialog";
import MailBrowserDialog from "@/components/dialogs/MailBrowserDialog";
import DeleteDepartmentDialog from "@/components/dialogs/DeleteDepartamentDialog";
import HelpDialog from "@/components/dialogs/HelpDialog";
import Events from "@/utils/Events";
import CloseUnsavedDialog from "@/components/dialogs/CloseUnsavedDialog";
import SaveOrReplaceDialog from "@/components/dialogs/SaveOrReplaceDialog";
import SelectInComboDialog from "@/components/dialogs/SelectInComboDialog";
import DateDialog from "@/components/dialogs/DateDialog";
import NumericDialog from "@/components/dialogs/NumericDialog.vue";
import CheckboxDialog from "@/components/dialogs/CheckboxDialog";
import ImportOrUpdateProductDialog from "@/components/dialogs/ImportOrUpdateProductDialog";
import UpdateDynamicAttributesDialog from "@/components/dialogs/UpdateDynamicAttributesDialog";
import RegionDialog from "@/components/dialogs/RegionDialog.vue";
import TranslationDialog from "@/components/dialogs/TranslationDialog.vue";
import PrintoutLanguageDialog from "@/components/dialogs/PrintoutLanguageDialog.vue";
import InterfaceLanguageDialog from "@/components/dialogs/InterfaceLanguageDialog.vue";
import InfoNewOrganization from "@/components/dialogs/InfoNewOrganization.vue";
import BinaryOptionDialog from "@/components/dialogs/BinaryOptionDialog.vue";
import InfoShortDialog from "@/components/dialogs/InfoShortDialog.vue";

let instance = null;
let DialogsMountPoint = {
  name: "DialogsMountPoint",

  components: {
    InfoShortDialog,
    BinaryOptionDialog,
    InfoNewOrganization,
    InterfaceLanguageDialog,
    TranslationDialog,
    RegionDialog,
    UpdateDynamicAttributesDialog,
    CheckboxDialog,
    DateDialog,
    NumericDialog,
    SelectInComboDialog,
    SaveOrReplaceDialog,
    CloseUnsavedDialog,
    HelpDialog,
    DeleteDepartmentDialog,
    MailBrowserDialog,
    AttachmentDialog,
    ShareAttachmentDialog,
    SelectInDataGridDialog,
    ImportOrUpdateProductDialog,
    YesNoDialog, ColumnsDialog, InfoDialog, TextareaDialog, HintEditorDialog, ErrorDialog, InputDialog,
    PendingDialog, LoggedOffDialog, CountDownDialog, ChangePasswordDialog, ImageDialog, MultiSelectDialog,
    ListOfImagesDialog, PrintoutLanguageDialog
  },
  mounted() {
    Log.info("DialogsMountPoint created.");
    DialogsMountPoint.instance = instance = this;
    this.login = SessionManager.isLoggedIn();
    this.$onEvent(Events.userSignedIn, login => {
      this.login = login;
    });
  },
  data: () => ({
    login: null
  }),
  methods: {
    getPopupGlass() {
      return document.getElementById("globalPopupGlass");
    },

    emptyPopupGlass() {
      this.getPopupGlass().replaceChildren();
    },

    addPopupToGlass(element) {
      this.getPopupGlass().appendChild(element);
    }

  }
}

DialogsMountPoint.getInstance = function () {
  return instance;
}


export default DialogsMountPoint;
</script>